import AICampusFooter from "@/components/probaworkflows_base_components/AICampusFooter/AiFooter.vue";
import GlobalTable from "@/components/probaworkflows_base_components/GlobalTable/GlobalTable.vue";
import {
  GET_ALL_USER_APPLICATIONS,
  GET_ENTITY_BY_USER,
  get_headers,
  LIST_ENTITY_ASSESSMENTS,
  STATUS_KEY_TO_FILTER,
} from "@/utils/constants/constants";
import alert_mixin from "@/utils/mixins/alert_mixin";
import formatting_mixins from "@/utils/mixins/formatting_mixins";
import axios from "axios";
import "datatables.net";
import "datatables.net-dt/css/dataTables.dataTables.css";
import $ from 'jquery';

export default {
  name: "ViewTrustForm",
  mixins: [alert_mixin, formatting_mixins],
  components: {
    GlobalTable,
    AICampusFooter,
  },
  data: () => ({
    hostname: window.location.hostname,
    activeFileTab: "employee", // Default active file tab
    activeSectionTab: "employment-info", // Default active section tab
    headers: "",
    application_list: [],
    application_table_headers: [],
    table_safe_application_list: [],
    selected_status: null,
    filter_by: [],
    dataTable: null,
    stored_form_count: null,
    total_assessment_count: 0,
    entities_for_user: [],
    total_pre_assessment_count: 0,
    total_post_assessment_count: 0,
    form_count: 0,
    DROPDOWN_STATUS_KEYS: ["approved", "declined", "pending"],
    STATUS_ALIASES: {
      pending: "in-progress",
      declined: "not-approved",
    },
  }),

  mounted() {
    this.headers = get_headers();
    this.apply_status_from_route();
    this.get_user_forms(this.selected_status);
    // this.fetch_assessments();
    this.fetch_entities_by_user();
  },
  watch: {
   "$route.query.status_id"() {
      window.location.reload();
    },
  },

  methods: {
    set_status_filter(key) {
      this.selected_status = (key || "");
        sessionStorage.setItem("filter_by", JSON.stringify([this.selected_status]));
        const normalized = this.normalize_key(this.selected_status);

        // server filter value using your constant (e.g., APPROVED, DECLINED, IN_PROGRESS)
        const serverFilter = normalized ? Reflect.get(STATUS_KEY_TO_FILTER, normalized) : null;
        this.get_user_forms(serverFilter);
    },

    apply_status_from_route() {
      var status = this.$route.query.status_id;
      this.selected_status = status || null;
    },

    get_user_forms(filter = null) {
      this.application_list = [];

      // send server-side filter if present
      const params = {filter_by: filter};

      axios
        .get(GET_ALL_USER_APPLICATIONS, {
          headers: this.headers,
          params,
        })
        .then((response) => {
          const data = response.data?.data || [];
          this.application_list = data;

          this.prep_tables();
        })
        .catch((error) => {
          const message =
            error.response?.data?.message || error.message || "Unknown error";
          this.show_error("Error getting forms: " + message);
        });
    },

    prep_tables() {
      const rows = (this.application_list || []).map((application) => {
        const child = application?.current_entity;
        const child_type = application?.current_entity_type;

        // Get the entity name here
        const entity_name = this.get_entity_name(application);

        return {
          "Application No": application?.id ?? "",
          "Name": entity_name, // Use the computed entity name
          "Trust Type Name": child_type?.entity_type_name ?? application?.entity_type?.entity_type_name ?? "",
          "Date Created": this.formatApplicationDate(application?.date_created),
          Status: (application?.status?.status ?? "").replace("_", " "),
          _entity_profile_id: child?.id ?? application?.entity ?? null,
          _child_entity_type_id: child_type?.id ?? null,
          _parent_entity_profile_id: application?.entity ?? null,
          _entity_type_id: application.entity_type.id,
          _entity_name: entity_name ,// Add this line to store the entity name
          _entity_type_name: child_type?.entity_type_name ?? application?.entity_type?.entity_type_name ??"",
        };
      });

      this.application_table_headers = rows.length
        ? Object.keys(rows[0]).filter((k) => !k.startsWith("_")).concat(["Actions"])
        : ["Application No", "Name", "Trust Type Name", "Date Created", "Status", "Actions"];

      this.table_safe_application_list = rows;
      this.initialize_data_table();
    },

    get_entity_name(application) {

       // 1 — Prefer entity_name
      if (application?.entity_name) {
        return application.entity_name.trim();
      }

      // 2 — Fallback: current_entity_name
      if (application?.current_entity_name) {
        return application.current_entity_name.trim();
      }

      const child_user = application?.current_entity?.user;
      if (child_user?.first_name && child_user?.last_name) {
        return `${child_user.first_name} ${child_user.last_name}`.trim();
      }

      const parent_user = application?.profile_role?.[0]?.user;
      if (parent_user?.first_name && parent_user?.last_name) {
        return `${parent_user.first_name} ${parent_user.last_name}`.trim();
      }
      return "Unknown Entity";
    },


    // Add this helper method to handle the date formatting
    formatApplicationDate(dateString) {
      if (!dateString) return "";

      try {
        // If the date is already in the format "Tue 19 August 2025 09:48"
        if (typeof dateString === "string" && dateString.includes("August")) {
          return dateString;
        }

        // If it's a proper date string that can be parsed
        const date = new Date(dateString);
        return new Intl.DateTimeFormat("en-GB", {
          weekday: "short",
          day: "numeric",
          month: "long",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
        }).format(date);
      } catch (error) {
        return dateString;
      }
    },

    initialize_data_table() {
      this.$nextTick(() => {
        if (this.dataTable) {
          this.dataTable.destroy();
        }

        this.dataTable = $('#entity_form_management_table').DataTable({
          responsive: true,
          emptyTable: "No data available in table",
          language: {
            info: "", // Capitalized "Entries"
            lengthMenu: "_MENU_&nbsp;&nbsp;Entries per page" // Added non-breaking space
          }
        });
      });
    },

    view_entity_application_overview(
        application_id,
        status,
        entity_profile_id,
        entity_type_id,
        entity_name,
        entity_type_name
      ) {
        // Persist data
        sessionStorage.setItem("application_id", application_id);
        sessionStorage.setItem("application_status", status);
        sessionStorage.setItem("entity_profile_id", entity_profile_id);
        sessionStorage.setItem("entity_type_id", entity_type_id);
        sessionStorage.setItem("entity_name", entity_name);
        sessionStorage.setItem("entity_type_name", entity_type_name);

        const type = (entity_type_name);
        let route_name = "";

        if (type === "Trustee") {
          route_name = "trustee_view_dashboard";
        } 
        else if (type === "Beneficiary") {
          route_name = "beneficiary_dashboard";
        } else if (type === "Founder") {
          route_name = "founder_dashboard";
        }else { 
          route_name = "entity_application_overview"; //default view for other entity types
        }
        

        // Navigate
        this.$router.push({
          name: route_name,
          params: {
            application_no: application_id,
            status: status,
            entity_profile_id: entity_profile_id,
            entity_type_id: entity_type_id,
            entity_name: entity_name,
            entity_type_name: entity_type_name
          },
          query: {
            entity_name: entity_name,
            entity_type_name: entity_type_name
          }
        });
      },

    async fetch_assessments() {
      const entity_type_id = sessionStorage.getItem("entity_type_id");
      if (!entity_type_id) {
        return;
      }

      try {
        const resp = await axios.get(LIST_ENTITY_ASSESSMENTS, {
          params: { entity_type_id: entity_type_id },
          headers: this.headers,
        });
        const body = resp.data;
        if (body.status === "success") {
          this.total_assessment_count = body.total_assessments;
          this.total_pre_assessment_count = body.total_pre_assessments;
          this.total_post_assessment_count = body.total_post_assessments;
        } else {
          this.total_assessment_count = 0;
        }
      } catch (err) {
        if (err.response?.status === 404) {
          this.total_assessment_count = 0;
          return;
        }
        let payload = err.response?.data;
        if (typeof payload === "string") {
          try {
            payload = JSON.parse(payload);
          } catch {
            payload = { message: "Error parsing response" };
          }
        }
        const msg = payload?.message || err.message;
        this.show_error("Assessments", msg);
      }
    },

    async fetch_entities_by_user() {
      const user_id = sessionStorage.getItem("user_id");
      if (!user_id) return;
      await this.load_user_entities(user_id);
    },

    /* eslint-disable no-useless-catch */
    load_user_entities(user_id) {
      return axios
        .get(GET_ENTITY_BY_USER, {
          params: { user_id: user_id, filter_by: this.selected_status },
          headers: this.headers || {},
        })
        .then(({ data: body }) => {
          if (body.status === "success") {
            this.entities_for_user = body.data;
            if (this.entities_for_user.length) {
              sessionStorage.setItem(
                "entity_type_id",
                this.entities_for_user[0].entity_type
              );
              sessionStorage.setItem("entity_id", this.entities_for_user[0].id);
            }
          } else {
            this.show_error(
              "Entities",
              body.message || "Could not load entities"
            );
          }
        })
        .catch((err) => {
          if (err.response?.status === 404) return;

          const payload =
            typeof err.response?.data === "string"
              ? JSON.parse(err.response.data)
              : err.response?.data || {};
          this.show_error("Entities", payload.message || err.message);
        });
    },

    redirect_to_view_all_user_assessments() {
      this.$router.push({
        path: "/entity_risk_assessment",
      });
    },

    format_status_label(key) {
      return (key || "").toString().replace(/[-_]/g, " ").replace(/\b\w/g, c => c.toUpperCase());
    },

    normalize_key(key) {
      if (!key) return "";
      const k = key.toString().trim().toLowerCase();
      const map = this.STATUS_ALIASES || {};
      // map aliases like "pending" -> "in-progress"
      return Object.prototype.hasOwnProperty.call(map, k) ? Reflect.get(map, k) : k;
    },
  },
};